import {
  HomeRounded,
  BarChartRounded,
  PeopleRounded,
  MoreHorizRounded,
  PointOfSaleRounded,
  ConfirmationNumberRounded,
  PaidRounded,
  PercentRounded,
  PersonAddRounded,
  GroupsRounded,
  ReceiptLongRounded,
  CalendarMonthRounded,
} from '@mui/icons-material';
import { ADMIN_ROLES } from '../../lib/constants';

const matchesPath = (pathname, matcher) => {
  if (!matcher) return false;
  if (typeof matcher === 'string') {
    return pathname === matcher || pathname.startsWith(`${matcher}/`);
  }

  return matcher(pathname);
};

export const isNavItemActive = (pathname, item) =>
  item.matchers?.some((matcher) => matchesPath(pathname, matcher)) ?? false;

const isAdminOrOwner = (session) => ADMIN_ROLES.includes(session?.role);

const canUseMainApp = (session) => session?.isActive !== false;

export const getPrimaryNavItems = (session) => {
  if (!canUseMainApp(session)) {
    return [
      {
        label: 'Mis Ventas',
        path: '/sales',
        icon: PointOfSaleRounded,
        matchers: ['/sales'],
      },
    ];
  }

  return [
    {
      label: 'Inicio',
      path: '/home',
      icon: HomeRounded,
      matchers: ['/', '/home'],
    },
    {
      label: isAdminOrOwner(session) ? 'Estadísticas' : 'Rendimiento',
      path: '/stats',
      icon: BarChartRounded,
      matchers: ['/stats'],
    },
    {
      label: 'Clientes',
      path: '/customers',
      icon: PeopleRounded,
      matchers: ['/customers'],
    },
    {
      label: 'Más',
      path: '/management',
      icon: MoreHorizRounded,
      matchers: ['/management'],
    },
  ];
};

export const getSecondaryNavItems = (session, hasStaffFeature = true, hasMemberships = true, hasAppointments = true) => {
  if (!canUseMainApp(session)) {
    return [];
  }

  const commonItems = [
    {
      label: 'Ventas',
      path: '/sales',
      icon: PointOfSaleRounded,
      matchers: ['/sales'],
    },
  ];

  commonItems.push({
    label: 'Agenda',
    path: '/appointments',
    icon: CalendarMonthRounded,
    matchers: ['/appointments'],
  });

  if (hasMemberships) {
    commonItems.push({
      label: 'Membresías',
      path: '/memberships',
      icon: ConfirmationNumberRounded,
      matchers: ['/memberships'],
    });
  }

  if (isAdminOrOwner(session)) {
    const adminItems = [...commonItems];
    
    if (hasStaffFeature) {
      adminItems.push({
        label: 'Liquidaciones',
        path: '/settlements',
        icon: PaidRounded,
        matchers: ['/settlements'],
      });
    }
    
    adminItems.push({
      label: 'Cierre de caja',
      path: '/daily-closing',
      icon: ReceiptLongRounded,
      matchers: ['/daily-closing'],
    });
    
    if (hasStaffFeature) {
      adminItems.push({
        label: 'Staff',
        path: '/staff',
        icon: GroupsRounded,
        matchers: ['/staff'],
      });
    }

    return adminItems;
  }

  const staffItems = [...commonItems];
  
  if (hasStaffFeature) {
    staffItems.push(
      {
        label: 'Comisiones',
        path: '/my-commissions',
        icon: PercentRounded,
        matchers: ['/my-commissions'],
      },
      {
        label: 'Mis Liquidaciones',
        path: `/settlements/${session?.user?.id}`,
        icon: PaidRounded,
        matchers: [
          (pathname) =>
            Boolean(session?.user?.id) &&
            (pathname === `/settlements/${session.user.id}` ||
              pathname.startsWith(`/settlements/${session.user.id}/`)),
        ],
      }
    );
  }

  return staffItems;
};

export const getQuickActionItems = (session, hasMemberships = true) => {
  if (!canUseMainApp(session)) {
    return [];
  }

  const actions = [
    {
      label: 'Cargar Venta',
      path: '/sales/new',
      icon: PointOfSaleRounded,
      color: '#3b82f6',
    },
    {
      label: 'Cargar Cliente',
      path: '/customers/new',
      icon: PersonAddRounded,
      color: '#10b981',
    },
  ];

  if (hasMemberships) {
    actions.push(
      {
        label: 'Cargar Membresía',
        path: '/memberships/new',
        icon: ConfirmationNumberRounded,
        color: '#8b5cf6',
      },
      {
        label: 'Consumir Membresía',
        path: '/memberships/consume',
        icon: ConfirmationNumberRounded,
        color: '#f59e0b',
      }
    );
  }

  return actions;
};
